import { render, staticRenderFns } from "./password_reset.vue?vue&type=template&id=6c49ceb8&scoped=true&"
import script from "./password_reset.vue?vue&type=script&lang=ts&"
export * from "./password_reset.vue?vue&type=script&lang=ts&"
import style0 from "./password_reset.vue?vue&type=style&index=0&id=6c49ceb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c49ceb8",
  null
  
)

export default component.exports